import { RouteObject, Navigate } from "react-router-dom";

export const legacyRoutes: RouteObject[] = [
  {
    path: "app/dashboard",
    element: <Navigate to="/dashboard" replace />,
  },
  {
    path: "app/calendar",
    element: <Navigate to="/calendar" replace />,
  },
  {
    path: "app/create",
    element: <Navigate to="/create" replace />,
  },
  {
    path: "app/settings",
    element: <Navigate to="/settings" replace />,
  },
  {
    path: "app/organisation",
    element: <Navigate to="/organisation" replace />,
  },
  {
    path: "app/setup",
    element: <Navigate to="/setup" replace />,
  },
  {
    path: "app/team",
    element: <Navigate to="/team" replace />,
  },
  {
    path: "app/team-management",
    element: <Navigate to="/team-management" replace />,
  },
  {
    path: "app/websites",
    element: <Navigate to="/websites" replace />,
  },
  {
    path: "app/sitemap",
    element: <Navigate to="/sitemap" replace />,
  },
];
